import { CHAIN_CONFIG } from '@/lib/api/relay'
import { readSplTokenBalance } from '../solana'
import type { MarketBalance, MarketWalletProvider } from '../types'

export const kalshiWalletProvider: MarketWalletProvider = {
	id: 'kalshi',
	label: 'Kalshi',
	direction: 'toKalshi',
	decimals: 6,
	chain: { chainId: CHAIN_CONFIG.solana.id, currency: CHAIN_CONFIG.solana.usdc },
	cashToken: {
		symbol: 'USDC',
		address: CHAIN_CONFIG.solana.usdc,
		decimals: 6,
	},
	resolveAddress: runtime => runtime.addressOverrides?.kalshi ?? runtime.solanaAddress ?? undefined,
	balanceQueryKey: address => ['market-balance', 'kalshi', address] as const,
	async readBalance(runtime): Promise<MarketBalance | null> {
		const address = this.resolveAddress(runtime)
		if (!(address && runtime.solanaConnection)) return null

		const cash = await readSplTokenBalance({
			connection: runtime.solanaConnection,
			owner: address,
			mint: CHAIN_CONFIG.solana.usdc,
			decimals: 6,
			symbol: 'USDC',
		})

		return { platform: 'kalshi', address, cash }
	},
	async readTokenBalance(runtime, request) {
		const address = request.address ?? this.resolveAddress(runtime)
		if (!(address && runtime.solanaConnection)) return null

		return readSplTokenBalance({
			connection: runtime.solanaConnection,
			owner: address,
			mint: request.tokenAddress,
			decimals: request.decimals,
			symbol: request.symbol ?? 'Token',
		})
	},
}
